export default "__VITE_ASSET__1a209a6d__"